import React, { forwardRef } from 'react';
import Avatar from 'react-avatar';
import { Button, Dropdown } from 'react-bootstrap';
import { HiOutlineLogout } from 'react-icons/hi';
import { MdOutlineWorkHistory } from "react-icons/md";

// project-imports
import { _setBgColor } from '../../utils';
import { GoogleAnalyticsEnum, triggerFunction } from '../../utils/google-analytics';
import { useUserContext } from '../../context/user_context';
import ToolTip from '../Tooltip/ToolTip';

// third-party
import { FaRegUser } from 'react-icons/fa';

const AvatarDropDown = ({ isLoggedIn, member }) => {

    // Reading data from context
    const { handleSignOut } = useUserContext();

    // Constatnt Vhild component
    const CustomToggle = forwardRef(({ children, onClick }, ref) => (
        <ToolTip title={(member && member?.userFullName) || "Guest User"} id={'t-1'}>
            <Button ref={ref} onClick={e => { e.preventDefault(); onClick(e); }} size='lg' variant='none' className='p-0 focus-ring focus-ring-secondary avatar-dropdown-icon'>
                {(member && member?.profileImg?.publicUrl) ? (
                    <img
                        src={(member && member?.profileImg?.publicUrl) || ""}
                        alt={member?.userFullName}
                        className="w-100 h-100 object-fit-cover rounded-circle"
                    />
                ) : (
                    <Avatar size={'100%'} maxInitials={1} color={"#525FE1"} name={(member && member?.userFullName) || "Guest User"} textSizeRatio={2.50} round />
                )}
            </Button>
        </ToolTip>
    ));

    const loggedUserDropDown = () => {

        return (
            <Dropdown className='rounded-5' size='lg' align={'end'}>
                <Dropdown.Toggle as={CustomToggle} className="dropdown" />
                <Dropdown.Menu className='custom-user-dropdown border-1 p-3 rounded-4'>
                    <Dropdown.Item disabled href="#/action-1">
                        <div className="row overflow-hidden py-4">
                            <div className='col-3 mx-auto my-auto'>
                                {(member && member?.profileImg?.publicUrl) ? (
                                    <div className="user-profile-small">
                                        <img
                                            src={(member?.profileImg?.publicUrl) || ""}
                                            alt={member?.userFullName}
                                            className="w-100 h-100 object-fit-cover rounded-circle"
                                        />
                                    </div>
                                ) : (
                                    <Avatar size='44' maxInitials={1} color={"#525FE1"} name={(member && member?.userFullName) || "Guest User"} textSizeRatio={2} round />
                                )}
                            </div>
                            <div className="col-9 align-items-center ">
                                <div className="fs-3 fw-bold text-dark text-truncate ... w-full">{(member && member?.userFullName) || "Guest User"}</div>
                                <div className="fs-4 fw-bold text-secondary mt-0.5 text-truncate ... w-full">{(member && member?.userId) || "Longswitch Academy"}</div>
                            </div>
                        </div>
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item href={process.env.PUBLIC_URL + `/user-details/${member && member?.userRecordId}`}>
                        <div className='fs-17 fw-bold text-secondary py-2'><FaRegUser /> My Profile</div>
                    </Dropdown.Item>
                    {/* <Dropdown.Item href={process.env.PUBLIC_URL + `/orders`}>
                        <div className='fs-17 fw-bold text-secondary py-2'><MdOutlineWorkHistory /> My Orders</div>
                    </Dropdown.Item> */}
                    <Dropdown.Item href="" onClick={() => { handleSignOut(); triggerFunction(GoogleAnalyticsEnum.BUTTON, GoogleAnalyticsEnum.LOGOUT_BUTTON); }}>
                        <div className='fs-17 fw-bold text-secondary py-2'><HiOutlineLogout /> Sign Out</div>
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        )
    }

    const defaultUserDropDown = () => {

        return (
            <Dropdown className='rounded-5' size='lg' align={'end'}>
                <Dropdown.Toggle as={CustomToggle} className="dropdown" />
                <Dropdown.Menu className='custom-user-dropdown border-1 p-3 rounded-4'>
                    <Dropdown.Item disabled href="#/action-1">
                        <div className="row overflow-hidden py-3">
                            <div className='col-3 mx-auto my-auto'>
                                <Avatar name={(member && member?.userFullName) || "Guest User"} maxInitials={1} color={"#525FE1"} size='44' textSizeRatio={2} round />
                            </div>
                            <div className="col-9 align-items-center ">
                                <div className="fs-3 fw-bold text-dark text-truncate ... w-full">Guest User</div>
                                <div className="fs-4 fw-bold text-secondary mt-0.5 text-truncate ... w-full">Longswitch Academy</div>
                            </div>
                        </div>
                    </Dropdown.Item>
                    <Dropdown.Divider />
                    <Dropdown.Item href="/login">
                        <Button className='edu-btn btn-medium w-full fs-3'>Sign In</Button>
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        )
    }

    return (
        <>
            {isLoggedIn ?
                loggedUserDropDown()
                :
                defaultUserDropDown()
            }
        </>
    )
}
export default AvatarDropDown;
